import { createFileRoute } from '@tanstack/react-router';
import { UnavailablePage } from '@portal/ui';

export const Route = createFileRoute('/_app/unavailable')({
  validateSearch: (search: Record<string, unknown>): { reason?: string; feature?: string } => ({
    reason: typeof search['reason'] === 'string' ? search['reason'] : undefined,
    feature: typeof search['feature'] === 'string' ? search['feature'] : undefined,
  }),
  component: Unavailable,
});

function Unavailable() {
  const { reason } = Route.useSearch();
  return <UnavailablePage reason={reason} />;
}
